import { Roles } from '.';

export class LoggedUser {
  displayName!: string;
  user_roles!: Roles[];
  idToken!: string;
  email?: string;
  expiresIn?: string;
  kind?: string;
  emailVerified!: boolean;
  ships?: string[];
}

export abstract class Role {
  static get_Role(myRole: string): Roles | undefined {
    const match = Object.entries(Roles).find(
      ([_, value]) => myRole.indexOf(value) > -1
    );
    return match ? match[1] : undefined;
  }
}
